import { render, staticRenderFns } from "./ChooseProducts.vue?vue&type=template&id=1a60403c&scoped=true&"
import script from "./ChooseProducts.vue?vue&type=script&lang=ts&"
export * from "./ChooseProducts.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseProducts.vue?vue&type=style&index=0&id=1a60403c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a60403c",
  null
  
)

export default component.exports